import { defineComponent as _defineComponent } from 'vue'
import { type PropType } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import { goBack } from '@/composables/useNavigation';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiBackButton',
  props: {
    fallbackTo: {
        type: Object as PropType<RouteLocationRaw>,
        required: true,
    },
},
  setup(__props, { expose: __expose }) {
  __expose();



const __returned__ = { get goBack() { return goBack } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})